export const SET_SHOPPER_SUBSCRIPTION_PLAN = 'SET_SHOPPER_SUBSCRIPTION_PLAN';
export const SET_AVAIL_SUBSCRIPTION_PLANS = 'SET_AVAIL_SUBSCRIPTION_PLANS';
export const SET_SELECTED_SUBSCRIPTION_PLAN = 'SET_SELECTED_SUBSCRIPTION_PLAN';
export const SET_AVAILABLE_SUBSCRIPTION_PLANS = 'SET_AVAILABLE_SUBSCRIPTION_PLANS';
